import { render } from "./PopUpShowObservations.vue?vue&type=template&id=692b6765"
import script from "./PopUpShowObservations.vue?vue&type=script&lang=js"
export * from "./PopUpShowObservations.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__